var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "page-btns" },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.showUpload,
              expression: "showUpload",
            },
          ],
        },
        [
          _c(
            "el-upload",
            {
              staticClass: "upload-demo",
              attrs: {
                headers: _vm.headers,
                action: _vm.uploadUrl,
                "before-upload": _vm.handlePreview,
                "on-success": _vm.handleSuccess,
                multiple: _vm.multiple,
                limit: _vm.limit,
                "on-exceed": _vm.handleExceed,
                "file-list": _vm.fileList,
                "show-file-list": false,
                accept: _vm.accept,
              },
            },
            [
              _c(
                "el-button",
                [
                  _c("svg-icon", {
                    staticStyle: { "margin-right": "4px" },
                    attrs: { "icon-class": "tn-upload" },
                  }),
                  _vm._v("\n        Upload file\n      "),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _vm._l(_vm.fileList, function (file, index) {
        return _c(
          "div",
          { key: index, staticClass: "spaceLeft file-list-item" },
          [
            _c("div", [_vm._v(_vm._s(file.name))]),
            _vm._v(" "),
            _c("svg-icon", {
              attrs: { "icon-class": "tn-delete" },
              on: {
                click: function ($event) {
                  return _vm.handleRemove(index)
                },
              },
            }),
          ],
          1
        )
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }